import { app } from "js/namespaces";

export function isCompactLibrary() {
    return app.isConstrained || app.isMobileOrTablet;
}
